import f3tch from 'f3tch';

import profile from '../../api/profiles/noData.profile.api';

export default (shortcutId) =>
  f3tch(`/crm/shortcuts/${shortcutId}/`).profile(profile()).delete();
